/** Product handle from a /products/<handle> URL, ignoring query and hash. */
function staProductHandleFromHref(href) {
  var m = String(href || '').match(/\/products\/([^/?#]+)/i);
  return m ? m[1].toLowerCase() : '';
}

/**
 * Which of the four search buckets a card belongs to. Lower sorts first:
 * live auctions, Buy Now, upcoming auctions, sold/past.
 *
 * The card's own badge wins where it has one, so the order can never contradict
 * what the shopper is looking at — those badges are written by the same API data
 * that replaced the card. Everything else falls back to the hidden product map in
 * theme.liquid, which carries buy-now, sold and auction-window state for the whole
 * catalogue. Unknown products (and articles/pages, which have no product link)
 * sort last rather than being dropped.
 */
function staSearchCardPhaseRank(wrap, liByHandle) {
  var link = wrap.querySelector('.sta-product-card__title a');
  if (!link) return 5;

  var badge = wrap.querySelector('.sta-product-card__badge');
  if (badge && !badge.hidden && badge.style.display !== 'none') {
    if (badge.classList.contains('_sold')) return 3;
    if (badge.classList.contains('_live')) return 0;
  }

  // Buy Now has two independent signals and needs both. The product map only flags
  // `data-buy-now` when custom.buy_now is set, whereas card-product.liquid marks a
  // card `data-buy-now-card` whenever the product belongs to no auction collection
  // — a broader condition, and the one that decides whether the shopper sees a BUY
  // NOW button. A product with the button but no metafield matched neither branch
  // and sorted below the sold lots.
  var isBuyNowCard = !!wrap.querySelector('.sta-product-card[data-buy-now-card="true"]');
  var li = liByHandle[staProductHandleFromHref(link.getAttribute('href'))];

  if (!li) return isBuyNowCard ? 1 : 4;

  if (li.getAttribute('data-lot-sold') === 'true') return 3;

  var nowTs = Math.floor(Date.now() / 1000);
  var startTs = parseInt(li.getAttribute('data-auction-start-ts') || '', 10);
  var endTs = parseInt(li.getAttribute('data-auction-end-ts') || '', 10);
  var hasWindow = isFinite(startTs) && isFinite(endTs) && startTs > 0 && endTs > 0;

  if (hasWindow && startTs <= nowTs && nowTs < endTs) return 0;
  if (li.getAttribute('data-buy-now') === 'true' || isBuyNowCard) return 1;
  if (isFinite(startTs) && startTs > nowTs) return 2;
  if (hasWindow && endTs <= nowTs) return 3;
  return 4;
}

/** Reorders search cards into live → buy now → upcoming → sold/past. */
function staSortSearchGridByAuctionPhase(grid) {
  // An explicit Sort by choice is the shopper's, not ours; only the default
  // (relevance) view is reordered.
  try {
    var chosenSort = new URLSearchParams(location.search || '').get('sort_by');
    if (chosenSort && chosenSort !== 'relevance') return;
  } catch (e) {}

  var wrappers = Array.prototype.slice.call(
    grid.querySelectorAll(':scope > .sta-collection-products__product')
  );
  if (wrappers.length < 2) return;

  var liByHandle = {};
  document.querySelectorAll('ul.urls-check-cards-products li[data-href]').forEach(function (li) {
    var handle = staProductHandleFromHref(li.getAttribute('data-href'));
    if (handle && !liByHandle[handle]) liByHandle[handle] = li;
  });

  var decorated = wrappers.map(function (wrap, index) {
    return { wrap: wrap, index: index, rank: staSearchCardPhaseRank(wrap, liByHandle) };
  });

  // Stable within a bucket, so Shopify's relevance order still decides the
  // running order of, say, the live auctions among themselves.
  decorated.sort(function (a, b) {
    return a.rank - b.rank || a.index - b.index;
  });

  // Pagination lives inside the grid and has to stay after the cards.
  var pagination = grid.querySelector(':scope > .pagination-wrapper');
  decorated.forEach(function (row) {
    grid.insertBefore(row.wrap, pagination || null);
  });
}

/**
 * Reorders a catalogue's lot grid so the lot ending first comes first — the same running
 * order as the homepage live-lots carousel. A card's end time comes from
 * data-sta-auction-end-ms (stamped from the auction API row, so it reflects any
 * extension) or else the hidden product map's data-auction-end-ts. Lots with no known
 * end sort last, in their original order.
 */
function staSortCatalogueGridByEndTime(grid) {
  if (!grid) return;
  // An explicit Sort by choice is the shopper's, not ours.
  try {
    if (new URLSearchParams(location.search || '').get('sort_by')) return;
  } catch (e) {}

  var wrappers = Array.prototype.slice.call(
    grid.querySelectorAll(':scope > .sta-collection-products__product')
  );
  if (wrappers.length < 2) return;

  var endMsByHandle = {};
  document.querySelectorAll('ul.urls-check-cards-products li[data-href][data-auction-end-ts]').forEach(function (li) {
    var handle = staProductHandleFromHref(li.getAttribute('data-href'));
    var endTs = parseInt(li.getAttribute('data-auction-end-ts') || '', 10);
    if (handle && endTs > 0 && !endMsByHandle[handle]) endMsByHandle[handle] = endTs * 1000;
  });

  var decorated = wrappers.map(function (wrap, index) {
    var endMs = parseInt(wrap.getAttribute('data-sta-auction-end-ms') || '', 10);
    if (!(endMs > 0)) {
      var link = wrap.querySelector('.sta-product-card__title a');
      endMs = link ? endMsByHandle[staProductHandleFromHref(link.getAttribute('href'))] : 0;
    }
    return { wrap: wrap, index: index, endMs: endMs > 0 ? endMs : Infinity };
  });

  decorated.sort(function (a, b) {
    if (a.endMs !== b.endMs) return a.endMs < b.endMs ? -1 : 1;
    return a.index - b.index;
  });

  // Pagination lives inside the grid and has to stay after the cards.
  var pagination = grid.querySelector(':scope > .pagination-wrapper');
  decorated.forEach(function (row) {
    grid.insertBefore(row.wrap, pagination || null);
  });
}

/** Search results: hide SSR auction cards until live + past scripts finish (see main-search.liquid loader). */
window.staMarkSearchAuctionPhase = function (phase) {
  if (typeof phase !== 'string') return;
  var s = window.__staSearchAuctionSync;
  if (!s) s = window.__staSearchAuctionSync = {};
  s[phase] = true;
  if (!s.live || !s.past) return;
  try {
    var grid =
      document.querySelector('.template-search #product-grid') || document.getElementById('product-grid');
    if (!grid) return;
    // Both enrichment passes are done, so every card now carries its final badge —
    // and the grid is still hidden, so the reorder happens before anything is seen.
    staSortSearchGridByAuctionPhase(grid);
    var loader = grid.querySelector('[data-sta-search-auction-loader]');
    if (loader) loader.remove();
    document.documentElement.classList.remove('sta-search-auction-pending');
  } catch (e) {}
};

document.addEventListener('DOMContentLoaded', function () {
  /** Reveal live auction catalogue grid after API filter/enrich completes. */
  window.staRevealLiveCatalogueGrid = function () {
    try {
      document.documentElement.classList.remove('sta-live-catalogue-pending');
      var grid = document.getElementById('product-grid');
      if (!grid || grid.getAttribute('data-direct-auction-catalogue') !== 'true') return;
      var overlay = grid.querySelector(':scope > .loading-overlay') || grid.querySelector('.loading-overlay');
      if (overlay) overlay.remove();
      if (typeof window.staSyncAuctionCatalogueHeroLots === 'function') {
        window.staSyncAuctionCatalogueHeroLots();
      }
    } catch (e) {}
  };

  /** Default collection templates render a loading overlay for auction JS; remove it when this script does not run replacement (e.g. /collections/all). */
  function removeIdleCollectionLoadingOverlay() {
    try {
      var grid = document.getElementById('product-grid') ||
        document.querySelector('.sta-collection-products__grid.collection') ||
        document.querySelector('.sta-collection-products__grid');
      if (!grid) return;
      if (grid.getAttribute('data-direct-auction-catalogue') === 'true') return;
      var overlay = grid.querySelector(':scope > .loading-overlay') || grid.querySelector('.loading-overlay');
      if (!overlay) return;
      if (overlay.getAttribute('data-sta-search-auction-loader') === 'true') return;
      if (grid.getAttribute('data-ended-auction-collection') === 'true') return;
      if (grid.getAttribute('data-department-duration-catalogues') === 'true') return;
      if (grid.getAttribute('data-buy-now-catalogue-lots-sync') === 'true') return;
      overlay.remove();
    } catch (e) {}
  }
  window.staRemoveIdleCollectionLoadingOverlay = removeIdleCollectionLoadingOverlay;

  var path = location.pathname || '';
  var replaceMatchedCollectionHandles = [
    'jewellery-fine-watches',
    'fine-decorative-art',
    'luxury-handbags-accessories',
    'antiques',
    'collectibles'
  ];

  function normalizeDurationRaw(raw) {
    var p = String(raw || '').trim().toLowerCase().replace(/\+/g, ' ')
      .replace(/\u2011/g, '-').replace(/\u2013/g, '-').replace(/\u2010/g, '-').replace(/\u2212/g, '-');
    if (p === 'buy' || p === 'buynow' || p === 'buy_now' || p === 'upcoming' || p === 'buy-now' || p === 'buy now') return 'buy-now';
    if (p === 'past' || p === 'ended') return 'ended';
    return p;
  }

  /** Duration from ?duration=, ?status=, or legacy ?filter-collection=handle=live */
  function durationFromSearch(search) {
    try {
      var params = new URLSearchParams(search || '');
      var raw = params.get('filter-collection') || '';
      var duration = '';
      if (raw) {
        var parts = raw.split('=').map(function (t) { return (t || '').trim(); }).filter(Boolean);
        duration = parts[1] || '';
      }
      duration = duration || params.get('duration') || params.get('status') || '';
      return normalizeDurationRaw(duration);
    } catch (e) {
      return '';
    }
  }

  var durationParam = durationFromSearch(location.search);
  var collectionPathMatch = /^\/collections\/([^/]+)\/?$/.exec(path || '');
  var collectionPathHandle = collectionPathMatch ? collectionPathMatch[1].toLowerCase() : '';
  var inferredCatalogueDuration = '';
  try {
    var gridInferProbe = document.getElementById('product-grid');
    if (gridInferProbe) {
      inferredCatalogueDuration = normalizeDurationRaw(gridInferProbe.getAttribute('data-infer-catalogue-duration') || '');
    }
  } catch (e) {}
  var effectiveDurationParam = durationParam || inferredCatalogueDuration;
  var departmentHandlesMap = {
    'jewellery-fine-watches': true,
    'fine-decorative-art': true,
    'luxury-handbags-accessories': true,
    'antiques': true,
    'collectibles': true
  };
  var isDepartmentDurationCataloguePage = !!(departmentHandlesMap[collectionPathHandle] && (durationParam === 'live' || durationParam === 'ended'));
  if (isDepartmentDurationCataloguePage) return;

  var pathNorm = (path || '').replace(/\/+$/, '') || '/';
  var isSearchPage = /\/search$/i.test(pathNorm);

  var isLuxury = path.indexOf('/collections/luxury-watches-collection') === 0;
  var isCatalogues = path.indexOf('/collections/catalogues') === 0;
  var isSpecialCollection = replaceMatchedCollectionHandles.some(function (handle) {
    return path.indexOf('/collections/' + handle) === 0;
  });

  /** /collections/<department>?duration=live|ended — same API filter behaviour as /collections/catalogues?collection=… */
  var isDepartmentCatalogueDuration = collectionPathHandle &&
    replaceMatchedCollectionHandles.indexOf(collectionPathHandle) !== -1 &&
    (effectiveDurationParam === 'live' || effectiveDurationParam === 'ended');
  var isAnyCollectionDurationView = collectionPathHandle &&
    collectionPathHandle !== 'catalogues' &&
    (effectiveDurationParam === 'live' || effectiveDurationParam === 'ended');

  var isDirectAuctionCatalogue = false;
  var isUpcomingAuctionCatalogue = false;
  try {
    var gridModeProbe = document.getElementById('product-grid');
    if (gridModeProbe && gridModeProbe.getAttribute('data-direct-auction-catalogue') === 'true') {
      isDirectAuctionCatalogue = true;
    }
    if (gridModeProbe && gridModeProbe.getAttribute('data-upcoming-auction-catalogue') === 'true') {
      isUpcomingAuctionCatalogue = true;
      // Upcoming lots stay server-rendered, so order them here from the product map.
      staSortCatalogueGridByEndTime(gridModeProbe);
    }
  } catch (e) {}

  // Luxury keeps the existing behavior (replace the full grid).
  // Special collections: default replaceMatched; with ?duration=live|ended use catalogues-style filter by department handle.
  // Direct auction catalogues (/collections/sc-catalog): keep SSR grid, enrich matched cards only.
  if (
    !isLuxury &&
    !isSpecialCollection &&
    !isCatalogues &&
    !isDepartmentCatalogueDuration &&
    !isAnyCollectionDurationView &&
    !isSearchPage &&
    !isDirectAuctionCatalogue
  ) {
    removeIdleCollectionLoadingOverlay();
    return;
  }

  // Upcoming auction catalogue (?duration=live on a catalogue whose start date is in the
  // future — e.g. the Preview link from the Live & Upcoming listing): keep the SSR lot
  // grid. The 'catalogues' replace mode below only keeps auctions that are live right
  // now, which would wipe every scheduled lot and render an empty page with 0 counts.
  if (
    isUpcomingAuctionCatalogue &&
    !isLuxury &&
    !isSpecialCollection &&
    !isCatalogues &&
    !isSearchPage
  ) {
    removeIdleCollectionLoadingOverlay();
    return;
  }

  var replaceMode = isCatalogues ? 'catalogues' : (isLuxury ? 'replaceGrid' : ((isDepartmentCatalogueDuration || (isAnyCollectionDurationView && !isDirectAuctionCatalogue)) ? 'catalogues' : 'replaceMatched'));

  // Buy-now department / catalogues hub: never replace the grid from the API.
  // 1) Liquid marks the grid with data-buy-now-catalogue-lots-sync when SSR matches.
  // 2) URL guard: when ?duration=buy-now, skip even if Liquid/cache omitted the attribute.
  function isBuyNowDurationFromUrl() {
    return durationFromSearch(location.search) === 'buy-now';
  }

  if (isBuyNowDurationFromUrl()) {
    if (document.querySelector('[data-buy-now-catalogue-lots-sync="true"]')) return;
    if (isCatalogues) return;
    if (collectionPathHandle && replaceMatchedCollectionHandles.indexOf(collectionPathHandle) !== -1) return;
  }

  // Department hub + ?duration=… but SSR still shows the default sub-collection listing (no #product-grid
  // or missing data attributes). theme.liquid will fetch the correct fragment — do not replaceMatched here
  // or we flash wrong API cards and fight the stabilization fetch.
  if (collectionPathHandle && replaceMatchedCollectionHandles.indexOf(collectionPathHandle) !== -1) {
    var guardDur = durationFromSearch(location.search);
    if (guardDur === 'live' || guardDur === 'ended' || guardDur === 'buy-now') {
      var deptPg = document.getElementById('product-grid');
      var deptPgOk =
        deptPg &&
        (deptPg.getAttribute('data-department-duration-catalogues') === 'true' ||
          deptPg.getAttribute('data-buy-now-catalogue-lots-sync') === 'true');
      if (!deptPgOk) {
        removeIdleCollectionLoadingOverlay();
        return;
      }
    }
  }

  // API base: from localStorage or fallback
  var API_BASE = (window.staAuctionsBase ? window.staAuctionsBase() : localStorage.getItem('sterlings_base_url') || '').replace(/\/+$/,'');

  // Prefer the main product grid id (avoids wiping the wrong section when multiple grids exist).
  var grid = document.getElementById('product-grid') ||
             document.querySelector('.sta-collection-products__grid.collection') ||
             document.querySelector('.sta-collection-products__grid');
  if (!grid) { console.warn('[auction-grid] grid not found'); return; }
  if (grid.getAttribute('data-department-duration-catalogues') === 'true') return;

  // --- The product card template as a STRING ---
  var CARD_HTML = '\
<div class="sta-collection-products__product">\
  <div class="sta-product-card">\
    <div class="sta-product-card__header">\
      <a href="#" class="sta-product-card__ill">\
        <img src="" alt="" class="sta-product-card__img" loading="lazy">\
      </a>\
      <span class="sta-product-card__badge sta-product-badge _live" style="display:none;">\
        <span class="sta-product-badge__name">Live</span>\
      </span>\
      <button class="sta-product-card__to-wish sta-wish-btn" title="Add to wishlist" aria-label="Add to wishlist">\
        <!-- (icon omitted for brevity) -->\
      </button>\
    </div>\
    <div class="sta-product-card__body">\
      <h3 class="sta-product-card__title"><a href="#">Auction Item</a></h3>\
      <div class="sta-product-card__auction">\
        <span data-auction-label>Live Auction</span>\
      </div>\
    </div>\
    <div class="sta-product-card__info">\
      <div class="sta-product-card__info-row sta-product-card__info-row--no-estimate">\
        <div class="sta-product-specs">\
        <div class="sta-product-spec">\
          <span class="sta-product-spec__ico"></span>\
          <div class="sta-product-spec__body">\
            <div class="sta-product-spec__title">SKU: —</div>\
          </div>\
        </div>\
        <div class="sta-product-spec">\
          <svg class="svg-ico sta-product-spec__ico">\
            <use xlink:href="//sterlingauctions.com/cdn/shop/t/3/assets/sprite.svg?v=122477482122922329031736255626#stopwatch"></use>\
          </svg>\
          <div class="sta-product-spec__body">\
            <div class="sta-product-spec__title">Ends —</div>\
            <p></p>\
          </div>\
        </div>\
        </div>\
        <div class="sta-product-card__estimate-slot" data-price-estimate-slot hidden></div>\
      </div>\
    </div>\
    <div class="sta-product-card__footer">\
      <div class="sta-product-card__bid-status" data-sta-bid-status-slot></div>\
      <div class="sta-product-card__price">\
        <div class="sta-product-spec__body sta-product-price">\
          <div class="sta-product-price__title">Current bid:</div>\
          <div class="sta-product-price__price"><small>$</small>0<span class="sta-money__code"> CAD</span></div>\
        </div>\
        <div class="sta-product-card__bids">\
          <svg class="svg-ico sta-product-card__bids-ico"><use xlink:href="//sterlingauctions.com/cdn/shop/t/3/assets/sprite.svg?v=122477482122922329031736255626#auction-hammer"></use></svg>\
          <div class="sta-product-card__bids-body">\
            <div class="sta-product-card__bids-count">0</div>\
            <div>Bids</div>\
          </div>\
        </div>\
      </div>\
      <a href="#" class="sta-btn _secondary _full center">Place Bid</a>\
    </div>\
  </div>\
</div>';

  // Helpers
  function pickArray(p){ return Array.isArray(p?.items) ? p.items
                              : Array.isArray(p?.data)  ? p.data
                              : Array.isArray(p)        ? p
                              : Array.isArray(p?.data?.data) ? p.data.data : []; }
  function attr(it,k){ return it && it.attributes ? it.attributes[k] : it ? it[k] : undefined; }
  function setMoneyPrice(el, dollars) {
    if (!el) return;
    if (window.staSetMoneyEl) window.staSetMoneyEl(el, dollars);
    else if (window.staFormatMoney) el.innerHTML = window.staFormatMoney(dollars);
  }

  /** After JS rewrites the grid, align hero + sort header counts with visible lot rows. */
  function syncCollectionPageCounts(gridEl) {
    if (!isLuxury && !isSpecialCollection && !isCatalogues && !isDepartmentCatalogueDuration && !isAnyCollectionDurationView && !isSearchPage && !isDirectAuctionCatalogue) return;
    var n = 0;
    if (gridEl) {
      gridEl.querySelectorAll(':scope > .sta-collection-products__product').forEach(function () {
        n++;
      });
    }
    var lotLabel = n === 1 ? '1 Lot' : n + ' Lots';
    document.querySelectorAll('.sta-collection-hero [data-collection-count]').forEach(function (el) {
      el.textContent = lotLabel;
    });
    var heroLotsById = document.getElementById('sta-hero-catalogue-lots-label');
    if (heroLotsById) heroLotsById.textContent = lotLabel;
    var productLabel = n === 1 ? '1 product' : n + ' products';
    var desk = document.getElementById('ProductCountDesktop');
    if (desk) desk.textContent = productLabel;
    var prodCount = document.getElementById('ProductCount');
    if (prodCount) prodCount.textContent = productLabel;
    document.querySelectorAll('.mobile-facets__count').forEach(function (el) {
      if (!el || !el.textContent) return;
      if (/\d+\s+products?/i.test(el.textContent)) el.textContent = productLabel;
    });
  }

  function normalizeToken(v){
    return String(v || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function parseCataloguesFilter() {
    var params = new URLSearchParams(location.search);
    var raw = params.get('filter-collection') || '';
    var collection = '';
    var duration = '';
    if (raw) {
      var parts = raw.split('=').map(function(p){ return (p || '').trim(); }).filter(Boolean);
      collection = parts[0] || '';
      duration = parts[1] || '';
    }
    collection = collection || params.get('collection') || '';
    duration = duration || params.get('duration') || params.get('status') || '';
    if (!String(duration || '').trim()) {
      try {
        var gInf = document.getElementById('product-grid');
        if (gInf) duration = gInf.getAttribute('data-infer-catalogue-duration') || '';
      } catch (e) {}
    }
    if (!String(duration || '').trim()) duration = 'live';
    duration = normalizeToken(duration);
    if (duration === 'past' || duration === 'ended') duration = 'ended';
    else if (duration === 'buy' || duration === 'buy-now' || duration === 'upcoming') duration = 'buy-now';
    else duration = 'live';

    collection = normalizeToken(collection);
    if (!collection) {
      var m = /^\/collections\/([^/]+)\/?$/.exec(location.pathname || '');
      var ph = m ? m[1].toLowerCase() : '';
      if (ph && ph !== 'catalogues') {
        collection = normalizeToken(ph);
      }
    }

    return {
      collection: collection,
      duration: duration
    };
  }

  // Card date + exact time, e.g. "7/24/2026 at 2:00 P.M EDT" (visitor
  // locale/timezone, timezone label from sta-time.js).
  function fmtDateTime(d) {
    if (window.staFormatDateTime) return window.staFormatDateTime(d, 'short');
    try {
      return d.toLocaleString();
    } catch (e) {
      return '';
    }
  }

  function startCountdown(bodyEl, endIso){
    var p = bodyEl.querySelector('p'); if (!p) { p = document.createElement('p'); bodyEl.appendChild(p); }
    function render(){
      var end = Date.parse(endIso || '');
      if (!isFinite(end)) { p.textContent = ''; return; }
      var s = Math.max(0, Math.floor((end - Date.now())/1000));
      var d = Math.floor(s/86400); s -= d*86400;
      var h = Math.floor(s/3600);  s -= h*3600;
      var m = Math.floor(s/60);    var sec = s%60;
      if (d+h+m+sec<=0) p.textContent = 'Ended';
      else p.textContent = d+'d '+String(h).padStart(2,'0')+'h '+String(m).padStart(2,'0')+'m '+String(sec).padStart(2,'0')+'s';
    }
    render();
    var t = setInterval(render,1000);
    var mo = new MutationObserver(function(){
      if (!document.body.contains(bodyEl)) { clearInterval(t); mo.disconnect(); }
    });
    mo.observe(document.body,{childList:true,subtree:true});
  }

  // Build headers (add ngrok header only if needed)
  var headers = window.staAuctionHeaders ? window.staAuctionHeaders() : { 'Accept':'application/json' };

  var cataloguesFilter = parseCataloguesFilter();
  if (replaceMode === 'catalogues' && cataloguesFilter.duration === 'ended') {
    // Ended mode is owned by past-auctions.js; avoid dual render race/flicker.
    return;
  }
  var endpoint = '/api/auctions';
  if (replaceMode === 'catalogues') {
    if (cataloguesFilter.duration === 'ended') {
      endpoint = '/api/auctions';
    } else if (cataloguesFilter.duration === 'buy-now') {
      // For department "buy-now" catalogue views we render via Liquid
      // (non-auction products per department) and skip JS replacement.
      // Still set endpoint for safety but it won't be used.
      endpoint = '/api/auctions';
    }
  }

  if (replaceMode === 'catalogues' && cataloguesFilter.duration === 'buy-now') {
    return;
  }

  if (replaceMode === 'catalogues' && cataloguesFilter.duration === 'live') {
    grid.innerHTML = '<div class="loading-overlay gradient"></div>';
  }

  if (isSearchPage) {
    window.__staSearchAuctionSync = {};
  }

  // Fetch
  fetch(API_BASE + endpoint, { headers: headers, mode: 'cors' })
    .then(function(r){ if(!r.ok) throw new Error('HTTP '+r.status); return r.json(); })
    .then(function(payload){
      var list = pickArray(payload);
      var now = Date.now();

      // Live only unless we're using status-specific catalogues endpoint.
      var live = replaceMode === 'catalogues' && cataloguesFilter.duration !== 'live'
        ? list
        : list.filter(function(row){
            var a = row.attributes || row;
            var status = String(a.status||'').toLowerCase();
            var sd = Date.parse(a.start_date || a.start_at || '');
            var ed = Date.parse(a.end_date   || a.end_at   || '');
            return isFinite(sd) && isFinite(ed) && sd <= now && now < ed &&
              !/disabled|ended|archive|complete|cancel/.test(status);
          });

      // Dedupe per product id (normalized gid/numeric)
      var seen = {};
      var items = live.filter(function(row){
        var a = row.attributes || row;
        var pid = normalizePlatformProductId(a.platform_product_id || a.product_id || '');
        if (pid && seen[pid]) return false;
        if (pid) seen[pid] = true;
        return true;
      });

      function normalizeProductPath(u){
        if (!u) return '';
        var s = String(u);
        try {
          // Handles both absolute URLs and /products/<handle> paths
          var parsed = /^https?:\/\//i.test(s) ? new URL(s) : new URL(s, window.location.origin);
          return (parsed.pathname.replace(/\/+$/, '') || '/');
        } catch (e) {
          return ((s.split('?')[0].split('#')[0]).replace(/\/+$/, '') || '/');
        }
      }

      function stripLeadingLocaleSegmentLive(pathN) {
        if (!pathN) return '';
        var p = pathN.replace(/\/+$/, '') || '/';
        var m = p.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?)\/(.*)$/i);
        if (m && m[1]) return ('/' + m[1]).replace(/\/+$/, '') || '/';
        return p;
      }
      function canonicalProductPathLive(u) {
        return stripLeadingLocaleSegmentLive(normalizeProductPath(u));
      }

      function normalizeSku(raw){
        if (!raw) return '';
        return String(raw).replace(/^SKU:\s*/i, '').trim().toLowerCase();
      }
      function normalizePlatformProductId(raw){
        if (!raw) return '';
        var s = String(raw).trim();
        if (!s) return '';
        var parts = s.split('/');
        return String(parts[parts.length - 1] || '').trim();
      }

      function productHandleFromPath(pathname){
        var path = normalizeProductPath(pathname);
        if (!path) return '';
        var m = path.match(/^\/products\/([^\/?#]+)/i);
        if (m && m[1]) return decodeURIComponent(m[1]).toLowerCase();
        var bare = path.replace(/^\/+/, '');
        if (bare && bare.indexOf('/') === -1) return decodeURIComponent(bare).toLowerCase();
        return '';
      }

      function productHandleFromRow(a){
        var direct = a.product_handle || a.handle || a.product_slug || '';
        if (direct) return String(direct).replace(/^\/+|\/+$/g, '').toLowerCase();
        return productHandleFromPath(a.product_url || '');
      }

      /** Shopify-rendered collection grid: product handles on the current page (before replace). */
      function collectGridProductHandles(gridEl) {
        var set = new Set();
        if (!gridEl) return set;
        gridEl.querySelectorAll('.sta-collection-products__product a[href*="/products/"]').forEach(function (a) {
          var h = productHandleFromPath(a.getAttribute('href') || '');
          if (h) set.add(h);
        });
        return set;
      }

      function buildAuctionUrl(a, row){
        var url = a.product_url || '#';
        var aid = (row && row.id) || a?.auction_id || a?.id;

        if (url && url !== '#') {
          var isAbs = /^https?:\/\//i.test(url);
          var isProductsPath = /^\/?products\//i.test(url);

          // If not absolute, normalize to /products/<handle> (or keep /products/... if already given)
          if (!isAbs) {
            url = isProductsPath
              ? (url.startsWith('/') ? url : '/' + url)
              : '/products/' + url.replace(/^\/+/, '');
            // Make absolute against current origin
            url = new URL(url, window.location.origin).href;
          }

          // Append auction_id
          try {
            var u = new URL(url);
            if (aid != null) u.searchParams.set('auction_id', String(aid));
            url = u.toString();
          } catch (_) { /* leave url as-is on parse error */ }
        }

        return url;
      }

      function renderAuctionCardFromRow(row, imageFallback){
        var a = row.attributes || row;

        // Create card from HTML string
        var tmp = document.createElement('div');
        tmp.innerHTML = CARD_HTML.trim();
        var card = tmp.firstElementChild;

        // Data
        var name = a.auction_name || a.product_name || a.name || 'Auction Item';
        var sku  = a.product_sku || '';
        var img  = a.product_image_url || a.image_url || imageFallback || '';
        var url  = buildAuctionUrl(a, row);
        var endIso = a.end_date || a.end_at;
        var pid = window.staProductNumericId
          ? window.staProductNumericId(a.platform_product_id || a.product_id)
          : '';
        var storeDollars = pid && window.staStorePriceDollars ? window.staStorePriceDollars(pid) : null;
        var price = window.staAuctionDisplayPrice
          ? window.staAuctionDisplayPrice(a, storeDollars)
          : (a.current_price != null)
            ? a.current_price
            : (a.starting_price != null)
              ? a.starting_price
              : (a.initial_price != null)
                ? a.initial_price
                : storeDollars;
        var bids   = a.bid_count || a.bids_count || 0;

        // A lot inside the 24h catalogue hold has finished but still sits in its live
        // catalogue, so it reaches this renderer down the "live" path. Present it as the
        // finished lot it is — otherwise it would read Live, run an Ends countdown and
        // offer Place Bid on an auction that can no longer take bids.
        var isEndedHoldLot = !!(
          window.staIsRecentlyEndedAuctionRow &&
          window.staIsRecentlyEndedAuctionRow(row)
        );
        var showAsEnded =
          (replaceMode === 'catalogues' && cataloguesFilter.duration === 'ended') ||
          isEndedHoldLot;
        var endedLotHasWinner = !!(
          window.staHasAuctionWinner && window.staHasAuctionWinner(a)
        );
        // An unsold held lot is converted to Buy Now by the app as soon as its auction
        // ends (price boosted, custom.buy_now set) and keeps its place here for the hold,
        // so it shows that result: its Buy Now price and a Buy Now button. Until the
        // conversion lands (a few minutes) it simply reads Ended.
        var heldLotMapLi = isEndedHoldLot && !endedLotHasWinner && pid
          ? document.querySelector('ul.urls-check-cards-products li[data-product-id="' + pid + '"]')
          : null;
        var isHeldBuyNowLot = !!(
          heldLotMapLi && heldLotMapLi.getAttribute('data-buy-now') === 'true' && storeDollars != null
        );
        if (isEndedHoldLot) card.setAttribute('data-sta-held-lot', 'true');

        // Lets sta-bid-status.js badge this card "Winning"/"Outbid". Without it the
        // card names no lot (it has no data-product-id either) and is skipped. It goes
        // on the inner .sta-product-card, which is what that script reads — `card`
        // here is the grid wrapper around it.
        var auctionId = (row && row.id) || a.auction_id || a.id;
        var productCard = card.querySelector('.sta-product-card');
        if (productCard && auctionId != null && String(auctionId).trim() !== '') {
          productCard.setAttribute('data-auction-id', String(auctionId).trim());
        }

        // Fill
        var link = card.querySelector('.sta-product-card__ill'); if (link) link.href = url;
        var imgEl = card.querySelector('.sta-product-card__img');
        if (imgEl) {
          if (img) {
            imgEl.src = img;
            imgEl.alt = name;
            imgEl.removeAttribute('srcset');
          } else {
            imgEl.removeAttribute('src');
            imgEl.alt = name;
          }
        }

        var badge = card.querySelector('.sta-product-card__badge');
        if (badge) {
          badge.style.display = '';
          var badgeName = badge.querySelector('.sta-product-badge__name');
          if (isEndedHoldLot && !endedLotHasWinner) {
            // Unsold: no "Sold" badge on a lot nobody won — same as the ended-catalogue
            // card for a Buy Now lot (past-auctions.js).
            badge.classList.remove('_live', '_sold');
            badge.style.display = 'none';
          } else if (showAsEnded) {
            // A past auction LOT reads "Sold" wherever it appears — only the parent
            // catalogue card says "Past". _sold carries the badge colour; without it
            // the same lot would read Sold in grey here and in brand colour on the
            // past-catalogue page (see past-auctions.js).
            badge.classList.remove('_live');
            badge.classList.add('_sold');
            if (badgeName) badgeName.textContent = 'Sold';
          } else if (replaceMode === 'catalogues' && cataloguesFilter.duration === 'buy-now') {
            badge.classList.remove('_live');
            if (badgeName) badgeName.textContent = 'Buy now';
          } else {
            badge.classList.add('_live');
            if (badgeName) badgeName.textContent = 'Live';
          }
        }

        var titleA = card.querySelector('.sta-product-card__title a');
        if (titleA) { titleA.textContent = name; titleA.href = url; }

        var auctionLabel = card.querySelector('.sta-product-card__auction [data-auction-label]');
        if (auctionLabel) {
          if (showAsEnded) auctionLabel.textContent = 'Past Auction';
          else if (replaceMode === 'catalogues' && cataloguesFilter.duration === 'buy-now') auctionLabel.textContent = 'Upcoming Auction';
          else auctionLabel.textContent = 'Live Auction';
        }

        var skuTitle = card.querySelector('.sta-product-spec__title');
        if (skuTitle) skuTitle.textContent = sku ? ('SKU: ' + sku) : 'SKU: -';

        // Ends + countdown (use second spec body if present)
        var bodies = card.querySelectorAll('.sta-product-spec__body');
        var endsBody = bodies[1] || bodies[0];
        if (endsBody) {
          var endsTitle = endsBody.querySelector('.sta-product-spec__title');
          if (showAsEnded) {
            if (endsTitle) endsTitle.textContent = isHeldBuyNowLot ? 'Buy now' : 'Ended';
            var endedP = endsBody.querySelector('p');
            if (endedP) endedP.textContent = '';
          } else if (replaceMode === 'catalogues' && cataloguesFilter.duration === 'buy-now') {
            var startIso = a.start_date || a.start_at;
            if (endsTitle && startIso) {
              var sd = new Date(startIso);
              endsTitle.textContent = 'Starts ' + fmtDateTime(sd);
            }
            if (startIso) startCountdown(endsBody, startIso);
          } else if (endsTitle && endIso) {
            var d = new Date(endIso);
            endsTitle.textContent = 'Ends ' + fmtDateTime(d);
            startCountdown(endsBody, endIso);
          }
        }

        var priceTitle = card.querySelector('.sta-product-price__title');
        if (priceTitle) {
          // A won lot reads "Hammer price:" here the same way the archive card does
          // (see lot-card-product.liquid); an unsold one keeps the latest-bid wording.
          if (isHeldBuyNowLot) priceTitle.textContent = 'Buy now price:';
          else if (showAsEnded) priceTitle.textContent = endedLotHasWinner ? 'Hammer price:' : 'Latest bid:';
          else if (replaceMode === 'catalogues' && cataloguesFilter.duration === 'buy-now') priceTitle.textContent = 'Starting bid:';
          else if (window.staAuctionLivePriceLabel) priceTitle.textContent = window.staAuctionLivePriceLabel(bids);
          else priceTitle.textContent = 'Current bid:';
        }
        var priceEl = card.querySelector('.sta-product-price__price');
        // The Buy Now price is the boosted variant price, not the auction's last bid.
        if (isHeldBuyNowLot) price = storeDollars;
        if (priceEl && price != null) setMoneyPrice(priceEl, price);

        var bidsEl = card.querySelector('.sta-product-card__bids-count'); if (bidsEl) bidsEl.textContent = bids;

        var cta = card.querySelector('.sta-btn._secondary') || card.querySelector('.sta-btn');
        if (cta) {
          // Red is for lots still open to bids; Buy Now and sold lots take
          // the plain blue button so they read differently at a glance.
          cta.classList.toggle('_secondary', !isHeldBuyNowLot && !isEndedHoldLot);
          if (isHeldBuyNowLot) {
            cta.href = url;
            cta.textContent = 'Buy Now';
          } else if (isEndedHoldLot) {
            // Bidding is over, but the whole point of the hold is letting people see how
            // the lot finished — so send them to the lot rather than hiding the button,
            // matching the sold-lot card in card-product.liquid.
            cta.href = url;
            cta.textContent = 'Lot Details';
          } else if (replaceMode === 'catalogues' && cataloguesFilter.duration === 'ended') {
            cta.style.display = 'none';
          } else if (replaceMode === 'catalogues' && cataloguesFilter.duration === 'buy-now') {
            cta.href = url;
            cta.textContent = 'View Details';
          } else {
            cta.href = url;
            cta.textContent = 'Place Bid';
          }
        }

        if (window.staApplyPriceEstimateToCard) {
          var estPid = window.staProductIdFromAuctionAttrs
            ? window.staProductIdFromAuctionAttrs(a, null)
            : normalizePlatformProductId(a.platform_product_id || a.product_id || '');
          window.staApplyPriceEstimateToCard(card, estPid);
        }

        return card;
      }

      function collectTokensByProduct() {
        var byPath = {};
        var byId = {};
        var knownIds = {};
        var mapEls = document.querySelectorAll('ul.urls-check-cards-products li[data-href][data-product-id]');
        mapEls.forEach(function(li){
          var href = li.getAttribute('data-href') || '';
          var productPath = normalizeProductPath(href);
          var productId = normalizePlatformProductId(li.getAttribute('data-product-id'));
          var rawCollectionTitles = String(li.getAttribute('data-collection-of-products') || '');
          var rawCollectionHandles = String(li.getAttribute('data-collection-handles-of-products') || '');
          var titleTokens = rawCollectionTitles.split('+').map(normalizeToken).filter(Boolean);
          var handleTokens = rawCollectionHandles.split('+').map(normalizeToken).filter(Boolean);
          var tokens = titleTokens.concat(handleTokens);
          if (productPath) byPath[productPath] = tokens;
          if (productId) {
            byId[productId] = tokens;
            knownIds[productId] = true;
          }
        });
        return { byPath: byPath, byId: byId, knownIds: knownIds };
      }

      if (replaceMode === 'catalogues') {
        // For department "buy-now" catalogue URLs we now render purely in Liquid
        // (non-auction products belonging to the department). Leave the server
        // grid intact and do not replace it with auction data here.
        if (cataloguesFilter.duration === 'buy-now') {
          return;
        }

        var tokensByProduct = collectTokensByProduct();
        var filtered = items.filter(function(row){
          if (!cataloguesFilter.collection) return true;
          var a = row.attributes || row;
          var productId = normalizePlatformProductId(a.platform_product_id || a.product_id);
          // Department catalogues must match CURRENT Shopify product ids only.
          // Avoid matching by handle/path, since handles can be reused after deletion.
          if (!productId || !tokensByProduct.knownIds[productId]) return false;
          var tokens = tokensByProduct.byId[productId] || [];
          return tokens.indexOf(cataloguesFilter.collection) !== -1;
        });

        grid.innerHTML = '';
        if (!filtered.length) {
          var empty = document.createElement('div');
          empty.style.padding = '12px';
          empty.textContent = 'No auctions found for selected filters.';
          grid.appendChild(empty);
          syncCollectionPageCounts(grid);
          return;
        }

        filtered.forEach(function(row){
          grid.appendChild(renderAuctionCardFromRow(row));
        });
        syncCollectionPageCounts(grid);
      } else if (replaceMode === 'replaceGrid') {
        var allowedHandles = collectGridProductHandles(grid);
        var gridItems = items;
        if (allowedHandles.size > 0) {
          gridItems = items.filter(function (row) {
            var a = row.attributes || row;
            var h = productHandleFromRow(a);
            return h && allowedHandles.has(h);
          });
        }
        grid.innerHTML = '';
        if (!gridItems.length){
          var empty2 = document.createElement('div');
          empty2.style.padding = '12px';
          empty2.textContent = 'No live auctions right now.';
          grid.appendChild(empty2);
          syncCollectionPageCounts(grid);
          return;
        }

        gridItems.forEach(function(row){
          grid.appendChild(renderAuctionCardFromRow(row));
        });
        syncCollectionPageCounts(grid);
      } else {
        // replaceMatched: keep existing cards and only swap auction ones.

        function buildIdByPathForEnrich() {
          var idByPath = {};
          document.querySelectorAll('ul.urls-check-cards-products li[data-href][data-product-id]').forEach(function (li) {
            var href = li.getAttribute('data-href') || '';
            var productPath = normalizeProductPath(href);
            var productId = normalizePlatformProductId(li.getAttribute('data-product-id'));
            if (productPath && productId) idByPath[productPath] = productId;
          });
          return idByPath;
        }

        function parseShowAuctionRow(payload) {
          if (!payload) return null;
          var data = payload.data && !Array.isArray(payload.data) ? payload.data : payload;
          if (!data) return null;
          if (Array.isArray(data)) {
            if (!data.length) return null;
            data = data[0];
          }
          var attrs = data.attributes || data;
          return { id: data.id, attributes: attrs };
        }

        function fetchAuctionRowForDirectCatalogue(productId, auctionApiId) {
          if (auctionApiId) {
            var customerId = window.staCurrentCustomerId ? window.staCurrentCustomerId() : '';
            var showPath = window.staAuctionShowPath
              ? window.staAuctionShowPath(auctionApiId, customerId)
              : '/api/auctions/' + encodeURIComponent(String(auctionApiId));
            return fetch(API_BASE + showPath, { headers: headers, mode: 'cors' })
              .then(function (r) {
                if (!r.ok) return null;
                return r.json();
              })
              .then(parseShowAuctionRow);
          }
          if (productId && window.staFetchAuctionsByProductIds) {
            return window.staFetchAuctionsByProductIds([productId], { perPage: 1 }).then(function (payload) {
              var rows = window.staPickAuctionArray ? window.staPickAuctionArray(payload) : (payload && payload.data) || [];
              if (!rows.length) return null;
              var row = rows[0];
              if (row && row.attributes) return row;
              return { id: row.id, attributes: row };
            });
          }
          return Promise.resolve(null);
        }

        function imageFallbackForEnrich(wrap, mapLi) {
          if (mapLi) {
            var fromMap = String(mapLi.getAttribute('data-product-image') || '').trim();
            if (fromMap) return fromMap;
          }
          var ssrImg = wrap ? wrap.querySelector('.sta-product-card__img') : null;
          if (ssrImg) {
            var fromSsr = ssrImg.currentSrc || ssrImg.src || '';
            if (fromSsr && fromSsr.indexOf('data:') !== 0) return fromSsr;
          }
          return '';
        }

        function isHiddenMapBuyNow(mapLi) {
          return mapLi && mapLi.getAttribute('data-buy-now') === 'true';
        }

        /**
         * facets.js replaces #ProductGridContainer's innerHTML on every AJAX filter/sort/page
         * change, which destroys the original #product-grid node and creates a new one with the
         * same id. The outer `grid` variable was captured once at initial page load, so relying on
         * it here would prune/enrich a detached, invisible node after any such AJAX re-render
         * (letting unauctioned Shopify products leak back into the visible grid). Always re-query
         * the live node instead.
         *
         * window.staEnrichDirectAuctionCatalogue is called unconditionally by facets.js after every
         * AJAX render, on any page that reaches the 'replaceMatched' branch (search pages, generic
         * mixed collections, etc.), not only genuine direct-auction-catalogue pages. Only the latter
         * carry data-direct-auction-catalogue="true" on #product-grid, so gate on that attribute to
         * avoid pruning unrelated pages' non-auction product cards.
         */
        function getCurrentDirectCatalogueGrid() {
          var currentGrid = document.getElementById('product-grid') || grid;
          if (!currentGrid || currentGrid.getAttribute('data-direct-auction-catalogue') !== 'true') return null;
          return currentGrid;
        }

        /**
         * theme.liquid renders the hidden product map inside its own {% paginate %}, and every
         * paginate tag on a request shares the ?page param. On any ?page=N>1 the map therefore
         * comes back empty, and every lot below would look "unknown" and get removed — blanking
         * the grid. Auction catalogues no longer paginate, but if the map is ever missing we keep
         * the server-rendered Shopify cards rather than deleting lots we simply cannot resolve.
         */
        function hiddenProductMapIsPresent() {
          return !!document.querySelector('ul.urls-check-cards-products li[data-product-id]');
        }

        function pruneDirectCatalogueGrid() {
          var currentGrid = getCurrentDirectCatalogueGrid();
          if (!currentGrid) return;
          if (!hiddenProductMapIsPresent()) return;
          currentGrid.querySelectorAll(':scope > .sta-collection-products__product').forEach(function (wrap) {
            var titleA = wrap.querySelector('.sta-product-card__title a');
            if (!titleA) {
              wrap.remove();
              return;
            }
            var productPath = normalizeProductPath(titleA.getAttribute('href') || '');
            var productId = buildIdByPathForEnrich()[productPath];
            if (!productId) return;
            var mapLi = document.querySelector(
              'ul.urls-check-cards-products li[data-product-id="' + productId + '"]'
            );
            // A held lot was converted to Buy Now at auction end but stays for the hold.
            if (isHiddenMapBuyNow(mapLi) && wrap.getAttribute('data-sta-held-lot') !== 'true') {
              wrap.remove();
              return;
            }
            if (!wrap.querySelector('a[href*="auction_id="]')) {
              wrap.remove();
            }
          });
        }

        function enrichDirectCatalogueGrid() {
          var currentGrid = getCurrentDirectCatalogueGrid();
          if (!currentGrid) return Promise.resolve();
          if (!hiddenProductMapIsPresent()) {
            if (window.staRevealLiveCatalogueGrid) window.staRevealLiveCatalogueGrid();
            syncCollectionPageCounts(currentGrid);
            return Promise.resolve();
          }
          var idByPath = buildIdByPathForEnrich();
          var wrappers = Array.prototype.slice.call(
            currentGrid.querySelectorAll(':scope > .sta-collection-products__product')
          );
          if (!wrappers.length) {
            if (window.staRevealLiveCatalogueGrid) window.staRevealLiveCatalogueGrid();
            syncCollectionPageCounts(currentGrid);
            return Promise.resolve();
          }
          var nowMs = Date.now();
          return Promise.all(
            wrappers.map(function (wrap) {
              var titleA = wrap.querySelector('.sta-product-card__title a');
              if (!titleA) {
                wrap.remove();
                return Promise.resolve();
              }
              var productPath = normalizeProductPath(titleA.getAttribute('href') || '');
              var productId = idByPath[productPath];
              if (!productId) {
                wrap.remove();
                return Promise.resolve();
              }
              var mapLi = document.querySelector(
                'ul.urls-check-cards-products li[data-product-id="' + productId + '"]'
              );
              var mapBuyNow = isHiddenMapBuyNow(mapLi);
              var auctionApiId = mapLi ? String(mapLi.getAttribute('data-auction-api-id') || '').trim() : '';
              return fetchAuctionRowForDirectCatalogue(productId, auctionApiId).then(function (row) {
                var showRow =
                  row &&
                  (!window.staShouldShowLiveCatalogueRow ||
                    window.staShouldShowLiveCatalogueRow(row, nowMs));
                // Buy Now lots only belong here while they are an unsold lot's 24h hold.
                if (
                  showRow &&
                  mapBuyNow &&
                  !(window.staIsRecentlyEndedAuctionRow && window.staIsRecentlyEndedAuctionRow(row, nowMs))
                ) {
                  showRow = false;
                }
                if (!showRow) {
                  wrap.remove();
                  return;
                }
                var imageFallback = imageFallbackForEnrich(wrap, mapLi);
                var card = renderAuctionCardFromRow(row, imageFallback);
                var rowAttrs = row.attributes || row;
                var endMs = Date.parse(rowAttrs.end_date || rowAttrs.end_at || '');
                if (endMs > 0) card.setAttribute('data-sta-auction-end-ms', String(endMs));
                wrap.replaceWith(card);
              });
            })
          ).then(function () {
            pruneDirectCatalogueGrid();
            // Still hidden behind sta-live-catalogue-pending, so the reorder is never seen.
            staSortCatalogueGridByEndTime(getCurrentDirectCatalogueGrid());
            if (window.staRevealLiveCatalogueGrid) window.staRevealLiveCatalogueGrid();
            syncCollectionPageCounts(getCurrentDirectCatalogueGrid());
            // Cards built here have empty wish buttons; let sta-wish.js inject the bookmark icon + state.
            if (window.staWishlistSyncButtons) window.staWishlistSyncButtons();
          });
        }

        window.staEnrichDirectAuctionCatalogue = enrichDirectCatalogueGrid;

        if (isDirectAuctionCatalogue) {
          var liveCatalogueRevealTimer = setTimeout(function () {
            if (window.staRevealLiveCatalogueGrid) window.staRevealLiveCatalogueGrid();
          }, 12000);
          return enrichDirectCatalogueGrid().finally(function () {
            clearTimeout(liveCatalogueRevealTimer);
          });
        }

        if (!items.length) return;

        var overlay = grid.querySelector('.loading-overlay');
        if (overlay) overlay.remove();

        var byProductPath = {};
        var byProductHandle = {};
        var byProductSku = {};
        var byProductId = {};
        items.forEach(function(row){
          var a = row.attributes || row;
          var productPath = normalizeProductPath(a.product_url);
          if (productPath) byProductPath[productPath] = row;
          var handle = productHandleFromRow(a);
          if (handle) byProductHandle[handle] = row;
          var sku = normalizeSku(a.product_sku || a.sku);
          if (sku) byProductSku[sku] = row;
          var productId = normalizePlatformProductId(a.platform_product_id || a.product_id);
          if (productId) byProductId[productId] = row;
        });

        var idByPath = {};
        var idByCanonicalPath = {};
        var mapEls = document.querySelectorAll('ul.urls-check-cards-products li[data-href][data-product-id]');
        mapEls.forEach(function(li){
          var href = li.getAttribute('data-href') || '';
          var productPath = normalizeProductPath(href);
          var productId = normalizePlatformProductId(li.getAttribute('data-product-id'));
          if (productPath && productId) idByPath[productPath] = productId;
          if (isSearchPage) {
            var cp = canonicalProductPathLive(href);
            if (cp && productId) idByCanonicalPath[cp] = productId;
          }
        });

        var replacedAny = false;
        var linkEls = grid.querySelectorAll('.sta-product-card__title a');
        linkEls.forEach(function(aEl){
          if (!aEl) return;
          var href = aEl.getAttribute('href');
          var productPath = normalizeProductPath(href);
          var handle = productHandleFromPath(href);

          var row;
          if (isSearchPage) {
            var cpSearch = canonicalProductPathLive(href);
            var pidSearch = idByCanonicalPath[cpSearch];
            if (!pidSearch) return;
            row = byProductId[pidSearch];
          } else {
            row = byProductPath[productPath] || byProductHandle[handle];
            if (!row) {
              var wrapper = aEl.closest('.sta-collection-products__product');
              // SKUs are not unique across auctions in this store, so the SKU fallback can only be
              // trusted as a last resort for auction cards. Buy-now cards also render a SKU spec,
              // and matching one against another product's auction row would swap a "Buy Now" card
              // for a bidding card.
              var isBuyNowCard = !!(wrapper && wrapper.querySelector('.sta-product-card[data-buy-now-card="true"]'));
              var skuEl = wrapper && !isBuyNowCard ? wrapper.querySelector('.sta-product-spec__title') : null;
              var sku = normalizeSku(skuEl && skuEl.textContent);
              if (sku) row = byProductSku[sku];
            }
            if (!row) {
              var productId = idByPath[productPath];
              if (productId) row = byProductId[productId];
            }
          }
          if (!row) return;

          var oldWrapper = aEl.closest('.sta-collection-products__product');
          if (!oldWrapper) return;

          oldWrapper.replaceWith(renderAuctionCardFromRow(row));
          replacedAny = true;
        });

        // If nothing matched, we leave the server-rendered grid as-is.
        if (!replacedAny) {
          if (isDirectAuctionCatalogue) {
            syncCollectionPageCounts(grid);
          }
          return;
        }

        // Drop products not tied to a live/upcoming auction row.
        if (!isSearchPage && !isDirectAuctionCatalogue) {
          grid.querySelectorAll(':scope > .sta-collection-products__product').forEach(function (wrap) {
            if (!wrap.querySelector('a[href*="auction_id="]')) wrap.remove();
          });
        }
        syncCollectionPageCounts(grid);
        // Replaced cards have empty wish buttons; let sta-wish.js inject the bookmark icon + state.
        if (window.staWishlistSyncButtons) window.staWishlistSyncButtons();
      }
    })
    .catch(function(err){
      console.error('[auction-grid] fetch failed:', err);
      if (isDirectAuctionCatalogue && grid) {
        if (typeof window.staEnrichDirectAuctionCatalogue === 'function') {
          window.staEnrichDirectAuctionCatalogue().finally(function () {
            if (window.staRevealLiveCatalogueGrid) window.staRevealLiveCatalogueGrid();
          });
        } else if (window.staRevealLiveCatalogueGrid) {
          window.staRevealLiveCatalogueGrid();
        }
      }
    })
    .finally(function () {
      if (typeof isSearchPage !== 'undefined' && isSearchPage && typeof window.staMarkSearchAuctionPhase === 'function') {
        window.staMarkSearchAuctionPhase('live');
      }
    });
});
